module.exports = __webpack_public_path__ + "img/emt_madrid_hero_card.72363249.png";